import { Home } from 'lucide-react';
import ChatCard from '../ChatCard';
import { Button } from '@/shared/ui/button.tsx';
import { Navigate, useNavigate } from 'react-router-dom';

type Props = {
  setStep: (id: "first" | "date" | "result" | "reasoning") => void,
  reasoning?: { name: string, why: string }
}

const Reasoning = ({ setStep, reasoning }: Props) => {

  const navigate = useNavigate()

  if(!reasoning) {
    return <Navigate to=".." />
  }

  return (
    <>
      <ChatCard user="client">
        <p className="w-full text-end font-poppins text-gray-500 text-sm">Why was {reasoning.name} selected</p>
      </ChatCard>
      <ChatCard user="assistant">
        <div className="w-full flex flex-col gap-8">
          <div className="w-full flex flex-col gap-3 ">
            <h3 className="font-poppins tracking-wider text-xl text-gray-500">{reasoning.name}</h3>
            <p className="font-poppins tracking-wider text-sm text-gray-500">{reasoning.why}</p>
            <div className="w-full flex items-center justify-end gap-2">
              <Button
                onClick={() => setStep("first")}
                variant="outline"
                size="icon"
                className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
              >
                <Home />
              </Button>
              <Button
                onClick={() => navigate(-1)}
                variant="outline"
                className="rounded-full font-poppins border-2 border-purple-400 hover:bg-white tracking-wide text-purple-600"
              >
                Return
              </Button>
            </div>
          </div>
        </div>
      </ChatCard>
    </>
  )
}

export default Reasoning;
